/* eslint-disable @typescript-eslint/no-explicit-any */
import { IMediaUpload } from '@/interfaces/media';
import {
  IPriceSales,
  ISearchPriceSalesReq,
  ISearchPriceSalesRes,
} from '../interfaces/price-sales';
import * as baseAdapter from './baseAdapter';

export const queryPriceSales = async () => {
  const ret = await baseAdapter.get<IPriceSales[]>('/priceSales');
  return ret;
};

export const getPriceSales = async (id: number) => {
  const ret = await baseAdapter.get<IPriceSales>('/priceSales/get/' + id);
  return ret;
};

export const searchPriceSales = async (req: ISearchPriceSalesReq) => {
  const ret = await baseAdapter.post<ISearchPriceSalesRes>(
    '/priceSales/gets',
    req,
  );
  return ret;
};

export const addPriceSales = async (data: Partial<IPriceSales>) => {
  const ret = await baseAdapter.post('/priceSales/create', data);
  return ret;
};

export const editPriceSales = async (data: Partial<IPriceSales>) => {
  const ret = await baseAdapter.put(`/priceSales/update/${data.id}`, data);
  return ret;
};

export const deletePriceSales = async (id: number) => {
  const ret = await baseAdapter.deleteRequest(`/priceSales/delete/${id}`);
  return ret;
};

export const uploadQuotation = async (data: Partial<IMediaUpload>) => {
  const ret = await baseAdapter.postForm('/priceSales/addQuotation', data);
  return ret;
};
